// Lightweight fallback shown while a lazy route chunk loads.
const RouteFallback = () => (
  <div className="min-h-screen bg-white flex items-center justify-center" data-testid="route-fallback">
    <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-[#E91E63]"></div>
  </div>
);

export default RouteFallback;
